import styled from 'styled-components';

const Text = styled.div`
  color: ${({ theme }) => theme.text.tableVulnName};
`;

export default Text;
